export default __webpack_public_path__ + "static/media/atm.8600da22.png";